import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  RetroplanningActionTypes,
  RetroplanningActionsUnion
} from '@core/actions/retroplanning.actions';
import { FollowsRetroplannings } from '@app/models';

export interface State extends EntityState<FollowsRetroplannings> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
  spinnerMessage: string;
  creating: boolean;
}

export const adapter: EntityAdapter<
  FollowsRetroplannings
> = createEntityAdapter<FollowsRetroplannings>({
  selectId: (retroplanning: FollowsRetroplannings) => retroplanning.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false,
  spinnerMessage: null,
  creating: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: RetroplanningActionsUnion
) {
  switch (action.type) {
    case RetroplanningActionTypes.Load:
      return { ...state, loading: true, busy: true };
    case RetroplanningActionTypes.LoadSingle:
      return { ...state, loading: true, busy: true };

    case RetroplanningActionTypes.LoadFail:
      return { ...state, loading: false, busy: false };
    case RetroplanningActionTypes.LoadSingleFail:
      return { ...state, loading: false, busy: false };

    case RetroplanningActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        busy: false
      };
    case RetroplanningActionTypes.LoadSingleSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        busy: false
      };
    case RetroplanningActionTypes.Create:
      return { ...state, creating: true };

    case RetroplanningActionTypes.CreateFail:
    case RetroplanningActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case RetroplanningActionTypes.AddAll:
      return adapter.addAll(action.retroplanning, state);

    case RetroplanningActionTypes.AddOne:
      return adapter.upsertOne(action.retroplanning, {
        ...state,
        loading: false
      });

    case RetroplanningActionTypes.UpdateOne:
      return adapter.updateOne(
        { id: action.retroplanning.id, changes: action.retroplanning },
        state
      );

    case RetroplanningActionTypes.UploadRetroplanning:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Retroplanning'
      };

    case RetroplanningActionTypes.UploadRetroplanningSucces:
      return {
        ...state,
        busy: false,
        spinnerMessage: ''
      };

    case RetroplanningActionTypes.DeleteRetroplanning:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Retroplanning'
      };

    case RetroplanningActionTypes.DeleteRetroplanningSuccess:
      return {
        ...state,
        busy: false,
        spinnerMessage: ''
      };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const getState = createFeatureSelector<State>('retroplannings');

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectBusy = (state: State) => state.busy;
export const selectSpinnerMessage = (state: State) => state.spinnerMessage;

export const getBusy = createSelector(
  getState,
  selectBusy
);

export const getSpinnerMessage = createSelector(
  getState,
  selectSpinnerMessage
);

export const getRetroplannings = createSelector(
  getState,
  selectAll
);
